import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import BasicLoader from "../../../../components/Loaders/BasicLoader";
import { AUTHENTICATED } from "../../../../constants/authEnums";

const RedirectPage = () => {
  const navigate = useNavigate();

  const authState = useSelector((state) => state?.appReducer?.authState);
  useEffect(() => {
    if (authState === AUTHENTICATED) {
      navigate("/user/dashboard");
    } else {
        window.location.href = `/login`
    }
  }, [authState])

  return <BasicLoader />;
};

export default RedirectPage;
